import { updateFormErrors } from "./updateFormErrors";

/**
 *
 * @param {string} newValue
 * @returns {void}
 */

export function checkInlineDoublePassword(newValue) {
  if (!newValue) {
    return;
  }

  const formIDs = [ 'form-register-password' ];

  let validates = true;

  formIDs.forEach((formID) => {
    const formObj = document.getElementById(formID);

    if (!formObj.checkValidity()) {
      validates = false;
    }
  });

  const repeatEmailFormElement = angular
    .element(form_register_password.passwordConfirm)
    .controller('ngModel');

  if (!repeatEmailFormElement) {
    return;
  }

  if (repeatEmailFormElement.$modelValue) {
    updateFormErrors('form-register-password');
  }

  repeatEmailFormElement.$validate();
  repeatEmailFormElement.$setValidity(
    'doublePassword', validates
  );

}
